import React from 'react';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import optimization from '../../../../images/optimization.png';
import LearnMoreCommon from '../LearnMoreCommon';

const BusinessWorkFlowOptimizationPage = props => {
    const { t } = props;
    return (
        <LearnMoreCommon
            cardMediaImage={optimization}
            cardMediaTitle={t(
                'landingPage.serviceSection.services.businessWorkFlowOptimization.header'
            )}
            headerTitle={t(
                'landingPage.serviceSection.services.businessWorkFlowOptimization.header'
            )}
            firstBlockText={t(
                'landingPage.serviceSection.services.businessWorkFlowOptimization.learnMore.firstBlock'
            )}
            contactUsDescription={t(
                'landingPage.serviceSection.services.businessWorkFlowOptimization.learnMore.contactUs'
            )}
            googleEventCategory="Services - BusinessWorkFlowOptimizationPage"
        />
    );
};

export default compose(withTranslation())(BusinessWorkFlowOptimizationPage);
